import { Breakpoint, Grid } from '@mui/material';
import CartLinkButton from 'src/features/cart/presentation/components/CartLinkButton';
import { FlexContainer } from '../styles';

interface HeaderCartProps {
  columns?: { [key in Breakpoint]?: number };
}

export default function HeaderCart({ columns }: HeaderCartProps) {
  const columnBreakpoints = columns ?? { xs: 2, sm: 1, md: 0.5 };

  return (
    <Grid item {...columnBreakpoints}>
      <FlexContainer sx={{ justifyContent: 'flex-end' }} pr={{ xs: 1, md: 0 }}>
        <CartLinkButton />
      </FlexContainer>
    </Grid>
  );
}
